import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UrgencyOption } from '@libs/store';
import { DropdownComponent } from '@libs/ui-lib';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lib-urgency-selector',
  imports: [DropdownComponent, TranslateModule],
  templateUrl: './urgency-selector.component.html',
  styleUrl: './urgency-selector.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UrgencySelectorComponent {
  @Input() public value: UrgencyOption = UrgencyOption.Medium;
  @Output() public readonly valueChange = new EventEmitter<UrgencyOption>();

  protected readonly UrgencyOption = UrgencyOption;

  protected onUrgencyChange(urgency: UrgencyOption | UrgencyOption[] | null): void {
    if (urgency === null) return;

    if (Array.isArray(urgency)) {
      urgency = urgency[0];
    }

    this.value = urgency;
    this.valueChange.emit(urgency);
  }
}
